import React, { Component } from 'react';
import HeaderModalStores from './HeaderModalStores';

const concidenceToFormat = [
  'VERACRUZ', 'MICHOACAN', 'COAHUILA', 'CDMX/ZONA METROPOLITANA', 'SAN LUIS POTOSÍ', 'NUEVO LEÓN',
];
class ModalAllStates extends Component {
  render() {
    const { withReturn = null, hideOverlay, stateOrZipSelectedUpdate } = this.props;
    const data = this.props.data?.stateListInfo ? this.props.data.stateListInfo : this.props.data || {};
    const dataValidate = data === null ? {} : data;

    const formatStatesArray = Object.keys(dataValidate).map((item) => {
      if (isNaN(item) || Number(item) > 32) return false;
      // ? UPGRADE
      if (/VERACRUZ\b/g.test(data[item])) {
        return {
          stateId: item.toString(),
          nameState: concidenceToFormat[0],
        };
      }

      if (/SAN LUIS POTOSI\b/g.test(data[item])) {
        return {
          stateId: item.toString(),
          nameState: concidenceToFormat[4],
        };
      }

      if (/NUEVO LEON\b/g.test(data[item])) {
        return {
          stateId: item.toString(),
          nameState: concidenceToFormat[5],
        };
      }

      if (/MICHOACAN\b/g.test(data[item])) {
        return {
          stateId: item.toString(),
          nameState: concidenceToFormat[1],
        };
      }

      if (/COAHUILA\b/g.test(data[item])) {
        return {
          stateId: item.toString(),
          nameState: concidenceToFormat[2],
        };
      }

      if (/CIUDAD\b/g.test(data[item])) {
        return {
          stateId: item.toString(),
          nameState: concidenceToFormat[3],
        };
      }

      return {
        stateId: item.toString(),
        nameState: data[item],
      };
    }).filter(Boolean);

    const sortAlphabeticallyStates = (
      formatStatesArray.sort((a, b) => {
        if (a.nameState < b.nameState) return -1;
        if (a.nameState > b.nameState) return 1;
        return 0;
      })
    );

    return (
      <section className="modalContainerStores" style={{ maxHeight: '560px' }}>
        <HeaderModalStores titleHeaderMod="Selecciona tu estado" withReturn={withReturn} closeModal={hideOverlay} />
        {
          sortAlphabeticallyStates.map(item => (
            <button
              className="resetDefaultStyleBtn"
              onClick={() => {
                stateOrZipSelectedUpdate(item);
                setTimeout(() => {
                  withReturn();
                }, 50);
              }}
              id={item.stateId}
            >{ item.nameState }</button>
          ))
        }
      </section>
    );
  }
}

export default ModalAllStates;
